/**
 * Public barrel export for the SelectableChip molecule (SE-5527).
 * @module components/molecules/SelectableChip
 */
export { default } from "./SelectableChipContainer";
export type { SelectableChipProps } from "./SelectableChipContainer";
